import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Este sistema incluye certificación?',
  answer: 'Los manuales son materiales de formación profesional en formato digital. No incluyen certificación oficial, ya que la certificación en Reiki depende de la práctica presencial con un maestro. Sin embargo, el conocimiento que adquieres es completo y te prepara para buscar esa certificación con una base sólida.'
}, {
  question: '¿Es un producto digital? ¿Cómo lo recibo?',
  answer: 'Sí, es 100% digital. Recibirás acceso inmediato a todos los materiales en formato PDF tras completar tu compra. Podrás descargarlos y acceder desde cualquier dispositivo.'
}, {
  question: '¿Necesito experiencia previa en Reiki?',
  answer: 'No. El sistema está diseñado para comenzar desde cero. El Nivel I parte de los fundamentos absolutos, y cada nivel construye progresivamente sobre el anterior.'
}, {
  question: '¿Cómo accedo al material después de comprar?',
  answer: 'Recibirás un email con tus links de descarga inmediatamente después de tu compra. El acceso es inmediato, las 24 horas, los 7 días de la semana.'
}, {
  question: '¿Tienen política de reembolso?',
  answer: 'Sí. Ofrecemos garantía de satisfacción de 7 días. Si por cualquier razón no estás satisfecho con el material, te devolvemos el 100% de tu inversión sin preguntas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 bg-[#0f0a2e]" data-id="element-169">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-170">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center" data-id="element-171">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-172">
          {faqs.map((faq, i) => <motion.div key={i} className="border-b border-purple-900/50" initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} data-id="element-173">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full py-6 flex justify-between items-center text-left focus:outline-none group" data-id="element-174">
                <span className="text-lg text-white font-medium group-hover:text-[#d4af37] transition-colors" data-id="element-175">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-[#d4af37] transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-176" />
              </button>
              <AnimatePresence data-id="element-177">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-178">
                    <p className="pb-6 text-purple-200 font-light leading-relaxed" data-id="element-179">
                      {faq.answer}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}